// extracted by mini-css-extract-plugin
module.exports = {"style":"Modal_style__a5scS"};